const holdingsItems = document.querySelectorAll(".holdingsPage__sections--item-bottom");
if (holdingsItems) {
    holdingsItems.forEach((item) => {
        let bar = item.querySelector(".bar");
        let bar2 = item.querySelector(".bar2");
        let val = item.querySelector("span");
        let perc = parseInt(val.textContent, 10);

        let p = { value: 0 };
        let animation = () => {
            p.value++;
            bar.style.transform = "rotate(" + (45 + (p.value * 1.8)) + "deg)";
            bar2.style.transform = "rotate(" + (45 + (p.value * 1.8)) + "deg)";
            val.textContent = p.value + "%";
            if (p.value < perc) {
                requestAnimationFrame(animation);
            }
        };

        requestAnimationFrame(animation);
    });
}